(() => {
  if (window.bljMemberEntryLoaded) return;
  window.bljMemberEntryLoaded = true;
  const initialize = () => {
    document.querySelectorAll('[data-blj-member]').forEach((panel) => {
      if (panel.dataset.initialized) return;
      panel.dataset.initialized = 'true';
      const status = panel.querySelector('[data-blj-member-status]');
      const trigger = panel.querySelector('summary');
      const links = [...panel.querySelectorAll('[data-blj-member-nav]')];
      let timer;
      let busy = false;
      const reset = (message = '') => {
        clearTimeout(timer);
        busy = false;
        links.forEach((link) => {
          link.removeAttribute('aria-disabled');
          link.removeAttribute('aria-busy');
        });
        status.textContent = message;
      };
      panel.addEventListener('click', (event) => {
        if (event.target.closest('[data-blj-member-close]')) {
          reset();
          panel.open = false;
          trigger.focus();
          return;
        }
        const link = event.target.closest('[data-blj-member-nav]');
        if (!link || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        if (busy) { event.preventDefault(); return; }
        if (navigator.onLine === false) {
          event.preventDefault();
          reset(panel.dataset.offline);
          return;
        }
        busy = true;
        links.forEach((entry) => { entry.setAttribute('aria-disabled', 'true'); entry.setAttribute('aria-busy', 'true'); });
        status.textContent = panel.dataset.working;
        timer = setTimeout(() => reset(panel.dataset.slow), 10000);
      });
      panel.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && panel.open) {
          event.preventDefault();
          reset();
          panel.open = false;
          trigger.focus();
        }
      });
      document.addEventListener('click', (event) => {
        if (panel.open && !panel.contains(event.target)) { panel.open = false; reset(); }
      });
      window.addEventListener('pagehide', () => reset());
      window.addEventListener('pageshow', (event) => reset(event.persisted ? panel.dataset.returned : ''));
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
